export enum FormId {
  PARTNERS_EXT = 406,
  PARTNER_LEGAL_EXTEND = 502,
  WW_PARTNERS = 575,
  LEGAL_ATTACHMENTS = 672,
}
